var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 33,
    viewBox: "0 0 39 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90454 16.6641C-0.968179 12.852 -0.968178 6.67128 2.90454 2.85914C6.77725 -0.953 13.0562 -0.952999 16.9289 2.85914L33.5243 19.195L19.5 33L2.90454 16.6641Z",
    fill: "#2A9DD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0711 2.8591C25.9438 -0.953035 32.2227 -0.953034 36.0955 2.8591C39.9682 6.67124 39.9682 12.8519 36.0955 16.6641L19.5 33L5.47566 19.195L22.0711 2.8591Z",
    fill: "#2A9DD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueHeartIcon);
export default __webpack_public_path__ + "static/media/blueHeartIcon.8a80bc6e9a1c30ed93823e98c82cb4ab.svg";
export { ForwardRef as ReactComponent };